'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import Layout from 'Layouts/Back';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import ModelPicker from 'Components/Forms/Elements/ModelPicker';
import DatePicker from 'Components/Forms/Elements/DatePicker';
import { action } from 'Shared/Routes';
import { formatNum } from 'Shared/utilities';
import Loader from 'Pure/Loader';
const {
  qwest,
  moment
} = window;
const listen_to = ['start', 'end', 'start_date', 'end_date', 'created_by'];
export default class AdminGlobalIndicatorPage extends Component {
  state = {
    start: moment().startOf('month').format('YYYY-MM-DD'),
    end: moment().endOf('month').format('YYYY-MM-DD'),
    status_messages: {},
    loading: true,
    start_date: '',
    end_date: ''
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchData();
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    const changed = Object.keys(state).filter(prop => listen_to.includes(prop)).some(prop => prev_state[prop] !== state[prop]);
    if (changed) component.fetchData();
  }
  handleFilterChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      [name]: value,
      info: undefined,
      error: undefined,
      warning: undefined
    });
  };
  fetchData = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post(action('GetAdminBookingsStats'), {
      start: state.start,
      end: state.end,
      created_by: state.created_by,
      booking_start: state.start_date,
      booking_end: state.end_date
    }).then(function (xhr, response) {
      component.setState({
        bookings_count: response.bookings_count,
        total_amount: response.total_amount,
        win_percent: response.win_percent,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['primary', 'bg-white']
    }) : undefined;
    let output = /*#__PURE__*/React.createElement(Layout, _extends({
      page_title: "Indicateurs pre-r\xE9servations"
    }, props), /*#__PURE__*/React.createElement("div", {
      className: "o-content dashboard-page"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters c-filters--admin-bookings-stats"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element is-date"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleFilterChange,
      value: state['start'],
      className: "cutom-date-picker",
      name: "start",
      label: "Date de cr\xE9ation",
      "allow-no-value": true,
      status: state.status_messages,
      bemit: ['filter']
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element-word"
    }, "Au"), /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleFilterChange,
      value: state['end'],
      className: "cutom-date-picker",
      name: "end",
      "allow-no-value": true,
      status: state.status_messages,
      bemit: ['filter']
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element is-picker"
    }, /*#__PURE__*/React.createElement(ModelPicker, {
      model: "Admin",
      onPick: component.handleFilterChange,
      picked: state['created_by'],
      name: "created_by",
      status_messages: state.status_messages
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element is-date"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleFilterChange,
      value: state['start_date'],
      className: "cutom-date-picker",
      name: "start_date",
      label: "Arriv\xE9e",
      "allow-no-value": true,
      status: state.status_messages,
      bemit: ['filter']
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element-word"
    }, "Au"), /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleFilterChange,
      value: state['end_date'],
      className: "cutom-date-picker",
      name: "end_date",
      "allow-no-value": true,
      status: state.status_messages,
      bemit: ['filter']
    }))), /*#__PURE__*/React.createElement("div", {
      className: "dashboard-table u-margin-bottom-25",
      style: {
        overflow: 'initial'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-stats"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-stats__item"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "c-stats__item-title u-no-margin-top"
    }, "Chiffre d'Affaires TTC"), /*#__PURE__*/React.createElement("div", {
      className: "c-stats__item-result"
    }, formatNum(state.total_amount, '0,0[.]00'), "\u20AC"), loader), /*#__PURE__*/React.createElement("div", {
      className: "c-stats__item"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "c-stats__item-title u-no-margin-top"
    }, "Nombre de dossiers"), /*#__PURE__*/React.createElement("div", {
      className: "c-stats__item-result"
    }, formatNum(state.bookings_count, '0,0')), loader), /*#__PURE__*/React.createElement("div", {
      className: "c-stats__item"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "c-stats__item-title u-no-margin-top"
    }, "Taux de transformation"), /*#__PURE__*/React.createElement("div", {
      className: "c-stats__item-result"
    }, state.bookings_count > 0 ? formatNum(state.win_percent, '0,0[.]00') : 'N/A', state.bookings_count > 0 ? '%' : undefined), loader)))));
    return output;
  }
}
